export default __webpack_public_path__ + "static/media/js-calcs-expression.fd45c491.jpg";